// extracted by mini-css-extract-plugin
module.exports = {"Comparison":"Comparison_Comparison__5ESwB"};